/* Keep Dawn's outer drawer/focus trap. Only these inline disclosures opt out of its sliding submenus. */
if (!customElements.get('ac-shop-navigation')) {
  customElements.define('ac-shop-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncCurrent = () => {
        this.querySelectorAll('.ac-shop-nav__shortcut').forEach((link) => {
          const destination = new URL(link.href, location.origin);
          const sort = destination.searchParams.get('sort_by');
          const isNew = new URLSearchParams(location.search).get('sort_by') === 'created-descending';
          const current = destination.pathname === location.pathname && (sort ? isNew : !isNew);
          if (current) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
      };
      this.syncCurrent();
      const grid = document.getElementById('ProductGridContainer');
      if (grid && !this.gridObserver) {
        this.gridObserver = new MutationObserver(this.syncCurrent);
        this.gridObserver.observe(grid, { childList: true });
      }
      if (this.initialized || !this.classList.contains('ac-shop-nav--drawer')) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.ac-shop-nav__group > summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        event.stopPropagation();
        summary.parentElement.open = !summary.parentElement.open;
      }, true);
      this.addEventListener('toggle', (event) => {
        if (event.target.matches('.ac-shop-nav__group')) {
          event.target.querySelector('summary').setAttribute('aria-expanded', String(event.target.open));
        }
      }, true);
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        const group = event.target.closest('.ac-shop-nav__group[open]');
        if (!group) return;
        event.stopPropagation();
        group.open = false;
        group.querySelector('summary').focus();
      }, true);
    }
    disconnectedCallback() {
      this.gridObserver?.disconnect();
      this.gridObserver = null;
    }
  });
}
